// src/components/energy-reset/StreakBar.tsx
type Props = {
  streak: number;
  timezone: string;
  percentToday: number; // % прошедшего дня (0..100)
  bestStreak?: number;  // рекорд за всё время (опционально)
};

export default function StreakBar({
  streak,
  timezone,
  percentToday,
  bestStreak = 0,
}: Props) {
  const tzLabel = (timezone || "").replaceAll("_", " ");

  return (
    <div className="rounded-2xl bg-white border border-gray-200 p-4 shadow-sm">
      <div className="flex items-baseline justify-between">
        <div className="text-sm opacity-70">Дней без пропуска</div>
        <div className="text-sm opacity-60">{tzLabel}</div>
      </div>

      <div className="mt-1 text-2xl font-semibold">{streak ?? 0}</div>

      <div className="mt-3 h-2 w-full bg-gray-100 rounded-full overflow-hidden" aria-label="Ход текущего дня">
        <div
          className="h-full bg-[#FF6F91] transition-all"
          style={{ width: `${Math.max(0, Math.min(100, percentToday))}%` }}
        />
      </div>

      <div className="mt-2 text-xs opacity-60">Отметь до 00:00 по твоей таймзоне</div>
      <div className="mt-1 text-xs text-gray-500">
        Лучший результат: <span className="font-semibold">{bestStreak}</span>
      </div>
    </div>
  );
}
